module.exports = __webpack_public_path__ + "img/ico-vlibras.9d7ae2cc.svg";